import { graphql } from '@repo/common/queries/schemas/server_user_query'

export const query_list_vaults = graphql(`
  query query_list_vaults {
    vaults {
      id
      symbol

      token_address

      vault_contract {
        address
      }
      vault_contract_history {
        address
        version
      }
    }
  }
`)
